import { ReactNode } from 'react';

import { Scroller, SxProps } from '@cast/design-system';

type DrawerScrollerProps = {
  children: ReactNode;
  sx: SxProps;
  setIsScrolledContent: (isScrolled: boolean) => void;
  setIsScrolledToBottom: (isScrolledToBottom: boolean) => void;
};

export const DrawerScroller = ({
  children,
  setIsScrolledContent,
  setIsScrolledToBottom,
  sx,
}: DrawerScrollerProps) => {
  return (
    <Scroller
      sx={sx}
      events={{
        scroll: (overlayScrollbar) => {
          const { scrollTop, scrollHeight, clientHeight } =
            overlayScrollbar.elements().target;
          const isScrolled = scrollTop > 0;
          const isScrolledToBottom = scrollTop === scrollHeight - clientHeight;

          setIsScrolledContent(isScrolled);
          setIsScrolledToBottom(isScrolledToBottom);
        },
      }}
    >
      {children}
    </Scroller>
  );
};
